import {

    BarChartOutlined,
    DotChartOutlined,
    ProductOutlined,
  } from "@ant-design/icons";
  import { Col, Layout,  Row } from "antd";
  import { useRef, useState } from "react";
import SummaryIndex from "./Components/Summary/SummaryIndex";
import MarketAnalysisIndex from "./Components/MarketAnalysis/MarketAnalysisIndex";
import CompetitorAnalysisIndex from "./Components/CompetitorAnalysis/CompetitorAnalysisIndex";
import ResponsiveMenu from "apps/Common/ResponsiveMenu";
import CountinueOnMobileApp from "apps/Common/CountiueOnMobileApp";

  
  const ReportIndex = () => {
     const containerRef = useRef(null)
    const { Sider, Content } = Layout;
    const [selectedKey, setSelectedKey] = useState<any>("summary");
    const items = [
      {
        key: "summary",
        label: "Özet",
        icon: <ProductOutlined/>,
      },
      {
        key: "marketAnalysis",
        label: "Piyasa Analizi",
        icon: <DotChartOutlined />,
      },
  
      {
        key: "competitorAnalysis",
        label: "Rakip Analizi",
        icon: <BarChartOutlined />,
      },
    ];
  
    return (
      <>
        <CountinueOnMobileApp
    isShowChildren={false}
    noDataSrc="https://cdn-icons-png.flaticon.com/512/3029/3029337.png"
    isShowDesc
    desc="Rapor sekmeleri yalnızca web sürümümüzde görüntülenebilir"
  useInWeb={true}>

      <Col span={24} className="!p-0">
         <Row 
          gutter={[
            { xs: 10, md:10 , xl:20 }, 
            { xs:10 , md: 15, xl:20}   
          ]}
         className="xl:!h-screen !bg-white" ref={containerRef}  >
         <Col xs={24}   xl={6} xxl={4} className="!rounded-lg ">
      
      <ResponsiveMenu
      
        containerRef={containerRef}
          currentStep={selectedKey}
          setCurrentStep={setSelectedKey}
          defaultSelectedKeys={["0"]}
          menuItems={items}
          onClick={(e) => setSelectedKey(e.key)}
        />
        
        

    </Col>
    <Col xs={24}  xl={18} xxl={20} className="  ">
        <Content className="!bg-white ">
        {(() => {
              if (selectedKey === "summary") {
                return (
                  <>
                    <SummaryIndex />
                  </>
                );
              } else if (selectedKey === "marketAnalysis") {
                return (
                  <>
                    <MarketAnalysisIndex />
                  </>
                );
              } else if (selectedKey === "competitorAnalysis") {
                return (
                  <>
                    <CompetitorAnalysisIndex />
                  </>
                );
              }
  
              return <></>;
            })()}
        </Content>
      </Col>
         </Row>
       
      </Col>
  </CountinueOnMobileApp>
      </>
    );
  };
  
  export default ReportIndex;
  